
import { FiSend } from 'react-icons/fi';
import { BackgroundEffects, TypingIndicator } from './components';

export const darkTheme = {
  id: 'dark',
  name: 'Dark',
  icon: 'microchip',
  color: 'blue',
  welcomeMessage: "SYSTEM.ASSIST//_ Ready to assist.",
  typography: "'Space Mono', monospace",
  description: 'A dark visual style.',
  preview: 'INITIALIZING NEURAL INTERFACE...',
  suggestedPrompts: [
    { text: 'Run diagnostics' },
    { text: 'System status?' },
    { text: 'Access logs' },
  ],
  
  // Layout configuration
  layout: {
    backgroundColor: 'bg-gray-900',
    textColor: 'text-gray-100',
    containerClasses: 'relative min-h-screen',
    headerClasses: 'bg-gray-800 border-b border-blue-500/30',
    chatContainerClasses: 'relative z-10',
    messageContainerClasses: 'space-y-4 p-4',
  },
  
  // Message styling
  messages: {
    user: {
      containerClasses: 'flex justify-end',
      messageClasses: 'bg-blue-600 text-white rounded-lg p-3 max-w-[80%] relative shadow-lg',
      textClasses: 'text-sm',
    },
    bot: {
      containerClasses: 'flex justify-start',
      messageClasses: 'bg-gray-800 text-gray-100 rounded-lg p-3 max-w-[80%] relative shadow-lg border border-blue-500/20',
      textClasses: 'text-sm',
    },
  },
  
  // Input styling
  input: {
    containerClasses: 'relative z-10 bg-gray-800/80 backdrop-blur border-t border-blue-500/30 p-4',
    inputClasses: 'w-full bg-gray-700 text-gray-100 rounded-lg pl-4 pr-12 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 border border-blue-500/20',
    buttonClasses: 'send-button-dark absolute right-6 top-1/2 -translate-y-1/2',
    buttonIcon: FiSend,
  },
  
  // Components
  components: {
    backgroundEffects: BackgroundEffects,
    typingIndicator: TypingIndicator,
  },
  
  // Animation classes
  animations: {
    messageAppear: 'animate-fade-in',
    backgroundElements: 'dark-grid dark-circuit-pattern',
    messageIn: 'cyber-reveal',
    messageOut: 'cyber-fade',
    typing: 'dark-typing-bounce',
    avatar: 'dark-avatar-spin',
    button: 'button-shine',
    scanline: 'scanning-light'
  },

  // Transitions
  transitions: {
    duration: '0.5s',
    timing: 'cubic-bezier(0.4, 0, 0.2, 1)',
    hover: '0.3s ease-in-out'
  },

  // Effects
  effects: {
    glow: 'shadow-lg shadow-blue-500/50',
    hover: 'translateY(-2px)',
    focus: 'ring-2 ring-blue-400',
    active: 'scale-95',
    grid: true,
    scanlines: true,
    neonBorder: true
  },

  // Embed code
  embedCode: `<script src="chatbot-loader.js"></script>
<script>
window.chatConfig = {
  theme: "dark",
  color: "#3B82F6",
  typography: "'Space Mono', monospace",
  welcomeMessage: "SYSTEM.ASSIST//_ Ready to assist.",
  userId: "user_cyber_123",
  chatbotId: "bot_cyber_001",
  animations: {
    enabled: true,
    duration: "0.5s",
    effects: {
      grid: true,
      scanlines: true,
      neonBorder: true
    }
  }
};
</script>`
};